// Push custom dataLayer to GTM and track custom events in both UA & GA4. Trigger - buttonClick
export function setGTMEvent(category: string, action: string, label: any) {
  if (window.dataLayer) {
    window.dataLayer.push({ 'event': 'buttonClick', 'category': category, 'action': action, label: label });
  }
}


